// extracted by mini-css-extract-plugin
module.exports = {"backdrop":"Modal_backdrop__3zBlP","modal":"Modal_modal__2HFlP","slide-down":"Modal_slide-down__1Lueg"};